import Vue from 'vue';
import LoadingV2 from '@/components/copyright/basics/loadingV2/index.vue'
let $vm

const plugin = {
  install (vue, pluginOptions = {}) {
    const TsaLoadingV2 = vue.extend(LoadingV2)
    if (!$vm) {
      $vm = new TsaLoadingV2({
        el: document.createElement('div')
      })
      document.body.appendChild($vm.$el)
    }
    
    const loading = {
      show (options = {}) {
        Vue.prototype.$toast.loading({
            message: options.message || '加载中',
            forbidClick: true,
            duration: 0,
            loadingType: 'spinner',
            className:'loadingToast'
        });
      },
      hide () {
        Vue.prototype.$toast.clear();
      }
    }
    if (!vue.prototype.$TsaLoadingV2) {
      vue.prototype.$TsaLoadingV2 = loading
    }
  }
}
export default plugin